import DestinationPage from '@/components/DestinationPage';

const Royan = () => {
  return (
    <DestinationPage
      title="Location de vélos à Royan"
      subtitle="Découvrez Royan et la Côte de Beauté à vélo : architecture, plages et nature"
      description="Royan et la Côte de Beauté offrent un cadre idéal pour le cyclotourisme. Parcourez les pistes cyclables le long des plages, découvrez l'architecture des années 50, explorez la forêt de la Coubre et visitez les villages ostréicoles. Une destination parfaite pour des vacances à vélo en famille."
      highlights={[
        "Pistes cyclables le long des 5 plages de Royan",
        "Architecture moderne et patrimoine",
        "Forêt de la Coubre et phare de Cordouan",
        "Villages ostréicoles de Mornac et Talmont",
        "Estuaire de la Gironde",
        "Itinéraires familiaux sécurisés"
      ]}
    />
  );
};

export default Royan;